import React, { useRef, useState } from "react";
import "./frameListModal.scss";
import { useNavigate } from "react-router-dom";
import closeIcon from "../../../images/modal/close-icon.svg";
import YellowButton from "../../buttons/defaultButton/yellowButton/YellowButton";
import useOnClickOutside from "../../../helpers/useOnClickOutside";
import { frameTypeList } from "../../../data/frameTypeList";
import greenArrowIcon from "../../../images/frames/green-check-icon.svg";

const FrameListModal = ({ isOpen, btnTitle, setIsOpen, selectedIFrameIndex, setIframeCount }) => {
    const modalRef = useRef();
    const navigate = useNavigate();
    useOnClickOutside(modalRef, () => setIsOpen(false));

    const [selectedFrame, setSelectedFrame] = useState(0);

    // const onSelectHandler = () => {
    //     navigate("/files/create/" + selectedFrame);
    //     setIsOpen(false);
    // };

    const setSelectedIframeHandler = () => {
        setIframeCount((prev) => {
            let mutatedArr = [...prev];
            mutatedArr[selectedIFrameIndex] = selectedFrame;
            return mutatedArr;
        });
        setIsOpen(false);
    };

    return (
        <>
            {isOpen && (
                <div className="modal-overlay">
                    <div className="frame-list-modal" ref={modalRef}>
                        <img
                            src={closeIcon}
                            alt="close"
                            className="frame-list-modal__close-btn"
                            onClick={() => setIsOpen(false)}
                        />
                        <div className="frame-list-modal__title">Оберіть фрейм з бібліотеки</div>
                        <div className="frame-list-modal__body">
                            {frameTypeList.map((frameType) => {
                                return (
                                    <div
                                        className={
                                            selectedFrame === frameType.id
                                                ? "frame-list-modal__body-frame frame-list-modal__body-frame-selected"
                                                : "frame-list-modal__body-frame"
                                        }
                                        onClick={() => setSelectedFrame(frameType.id)}
                                        key={frameType.id}
                                    >
                                        {selectedFrame === frameType.id && (
                                            <div className="frame-list-modal__body-frame-arrow">
                                                <img
                                                    src={greenArrowIcon}
                                                    alt="arrow"
                                                    className="frame-list-modal__body-frame-arrow-icon"
                                                />
                                            </div>
                                        )}
                                        <img
                                            src={frameType.link}
                                            alt="frame"
                                            className="frame-list-modal__body-frame-img"
                                        />
                                    </div>
                                );
                            })}
                        </div>
                        <div className="frame-list-modal__footer">
                            <YellowButton text={btnTitle} onClick={setSelectedIframeHandler} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FrameListModal;
